export default __webpack_public_path__ + "static/media/VidurSystem.8452ebd6.webp";